<template>
  <div class="is-inline-block" @click="handleRootClick($event)">
    <div :class="{'dropdown': true, 'is-active': opened }">
      <div class="dropdown-trigger">
        <button class="button multiselect__button" aria-haspopup="true" aria-controls="dropdown-menu" @click="toggleOpen()">
          <div class="multiselect__wrap">
          <span v-if="selected.length === 0">None</span>
          <div v-if="selected.length > 0" >
            <div v-for="key in selected"
              :key="key"
              class="multiselect__tag"
              @click="handleTagClick($event)">
              <div class="tags has-addons">
                <span class="tag is-light">{{items[key]}}</span>
                <a class="tag is-delete is-danger" @click="select(key)"></a>
              </div>
            </div>
          </div>
          </div>
          <span :class="{'icon':true, 'is-small': true, 'is-hidden': opened}">
            <i class="fas fa-angle-down" aria-hidden="true"></i>
          </span>
          <span :class="{'icon': true, 'is-small': true, 'is-hidden': !opened}">
            <i class="fas fa-angle-up" aria-hidden="true"></i>
          </span>
          <span class="is-hidden"></span>
        </button>
      </div>
      <div class="dropdown-menu " id="dropdown-menu" role="menu">
        <div class="dropdown-content multiselect__menu">
          <a v-for="item in itemsArr"
            href="#"
            :key="item.key"
            :class="{'dropdown-item': true, 'is-active': isSelected(item) }"
            @click="select(item.key)">
            {{item.value}}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'multiselect',
  props: {
    items: {
      type: Object,
      default: {}
    },
    selected: {
      type: Array,
      default: () => []
    },
    onChanged: {
      type: Function,
      defualt: function () {}
    }
  },
  data () {
    return {
      opened: false
    }
  },
  computed: {
    itemsArr () {
      var result = []
      for (var key in this.items) {
        result.push({key: key, value: this.items[key]})
      }
      return result
    }
  },
  methods: {
    select (key) {
      let index = this.selected.indexOf(key)
      if (index === -1) {
        this.selected.push(key)
      } else {
        this.selected.splice(index, 1)
      }
      window.console.log('onChanged', this.onChanged)
      this.onChanged(this.selected)
    },
    isSelected (item) {
      return this.selected.indexOf(item.key) !== -1
    },
    toggleOpen () {
      this.opened = !this.opened
    },
    handleTagClick (e) {
      e.stopPropagation()
    },
    handleRootClick (e) {
      e.stopPropagation()
    },
    handleHtmlClick () {
      this.opened = false
    }
  },
  mounted () {
    document.addEventListener('click', this.handleHtmlClick)
  },
  destroyed () {
    document.removeEventListener('click', this.handleHtmlClick)
  }
}
</script>

<style>
.multiselect__menu {
  max-height: 50vh;
  overflow-y: auto;
}

.multiselect__button {
  max-width: 50vw;
  height: auto;
}

.multiselect__tag {
  padding: 0.25em 0;
}

.multiselect__wrap::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.multiselect__wrap::-webkit-scrollbar-track {
    background: rgb(179, 177, 177);
    border-radius: 10px;
    border: 3px solid transparent;
}

.multiselect__wrap::-webkit-scrollbar-thumb {
    background: rgb(136, 136, 136);
    border-radius: 10px;
}

.multiselect__wrap::-webkit-scrollbar-thumb:hover {
    background: rgb(100, 100, 100);
    border-radius: 10px;
}

.multiselect__wrap::-webkit-scrollbar-thumb:active {
    background: rgb(68, 68, 68);
    border-radius: 10px;
}

.multiselect__tag {
  margin-right: 0.5em;
}
</style>


// WEBPACK FOOTER //
// front/src/components/common/multiselect.vue